module.exports = __webpack_public_path__ + "static/media/arrow-left.432dc5eb.svg";